module.exports = __webpack_public_path__ + "img/zitu_bg_icon.b6a2d715.png";